<div id="form-container">
  @if (audienceForm) {
    <form
      [formGroup]="audienceForm"
      id="audience-form"
      class="col col-m-7 col-l-8 col-xl-8 col-xxl-7 lpb-8"
      (ngSubmit)="onSubmit()"
      >
      <h3 class="ui-heading-3-bold">
        {{ !selectedAudience || selectedAudience.id === 0 ? 'Add Audience' : 'Edit Audience' }}
      </h3>
      <div id="editable">
        <rds-form-field labelPosition="side-left">
          <rds-control-label>Audience Type <span class="c-error">*</span></rds-control-label>
          <rds-autocomplete
            [options]="audienceTypes"
            placeholder="Select audience type..."
            [highlightQuery]="false"
            minSearchChars="0"
            formControlName="type"
            debounce="0"
            displayProperty="label"
            uniqProperty="value"
            />
        </rds-form-field>
        @if (showSpecialistField) {
          <rds-form-field labelPosition="side-left">
            <rds-control-label>Specialist <span class="c-error">*</span></rds-control-label>
            <rds-autocomplete
              [options]="specialists"
              placeholder="Select specialist type..."
              [highlightQuery]="false"
              minSearchChars="0"
              formControlName="specialist"
              debounce="0"
              displayProperty="label"
              uniqProperty="value"
              />
          </rds-form-field>
        }
        <rds-form-field labelPosition="side-left">
          <rds-control-label>Description</rds-control-label>
          <textarea
            rdsInput
            formControlName="description"
            placeholder="Description of the audience"
            rows="3"
          ></textarea>
        </rds-form-field>
        <div class="custom-form-field">
          <label class="field-label">Color <span class="c-error">*</span></label>
          <div class="color-picker-grid">
            @for (color of colorOptions; track color) {
              <button
                type="button"
                class="color-option"
                [class.selected]="audienceForm.get('color_code')?.value === color"
                [style.background-color]="color"
                (click)="selectColor(color)"
                [attr.aria-label]="'Select color ' + color"
                >
              </button>
            }
          </div>
        </div>
      </div>
      <div id="controls" rds-drawer-actions class="button-controls">
        @if (selectedAudience && selectedAudience.id !== 0) {
          <button
            rds-secondary-warning-button
            type="button"
            (click)="onDelete()"
            class="delete-button"
            >
            Delete
          </button>
        }
        <button
          rds-primary-button
          type="submit"
          class="update-button"
          [disabled]="isLoadingChanges"
          >
          @if (!isLoadingChanges) {
            {{ !selectedAudience || selectedAudience.id === 0 ? 'Add' : 'Update' }}
          } @else {
            <rds-progress-spinner label="Saving..." size="m" white></rds-progress-spinner>
          }
        </button>
      </div>
    </form>
  }
</div>
